<template>
  <v-content class="grey lighten-3">
    <div id="core-view">
      <v-fade-transition mode="out-in">
        <router-view />
      </v-fade-transition>
      <v-snackbar
        :value="notification.show"
        :color="notification.color"
        :timeout="notification.timeout"
        :multi-line="notification.multiline"
        :right="true"
        :top="true"
        dark
        @input="HIDE_NOTIFICATION"
      >
        <v-icon
          color="white"
          class="mr-3"
        >
          mdi-{{ notification.icon }}
        </v-icon>
        <div>{{ notification.body }}</div>
        <v-btn @click="HIDE_NOTIFICATION" :to="notification.link.to" v-if="notification.link" text dark small denso>
          {{notification.link.body}}
        </v-btn>
        <v-btn
          icon
          @click="HIDE_NOTIFICATION"
        >
          <v-icon>
            mdi-close-circle
          </v-icon>
        </v-btn>
      </v-snackbar>
    </div>
  </v-content>
</template>

<script>
  import {
    mapMutations,
    mapState,
  } from 'vuex'

  export default {
    name: 'CoreView',

    metaInfo () {
      return {
        title: 'Acesso - UFJF',
      }
    },
    mounted () {
      if (localStorage.user) {
        this.LOAD_USER_FROM_LOCAL_STORAGE()
      }
    },
    computed: {
      ...mapState('app', ['notification']),
    },
    methods: {
      ...mapMutations('app', ['HIDE_NOTIFICATION']),
      ...mapMutations('account', ['LOAD_USER_FROM_LOCAL_STORAGE']),
    },
  }
</script>
